import { render } from "./CategoryList.vue?vue&type=template&id=14a04ea0&ts=true"
import script from "./CategoryList.vue?vue&type=script&lang=ts"
export * from "./CategoryList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__